module.exports = "data:image/png;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAEAfQ//73v7OBiOh/AAA="